import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function WhatYouGetSection() {
  const items = [{
    title: 'El Manual Completo',
    desc: "'Método 7-D Mornings' (Guía paso a paso)."
  }, {
    title: 'El Protocolo CES',
    desc: 'De 3 pasos para realizar bajo las cobijas.'
  }, {
    title: 'Guía de Salmos de Almohada',
    desc: 'Para interrumpir pensamientos intrusivos.'
  }, {
    title: 'Checklist de Inercia Cero',
    desc: 'Tu mapa visual de victoria diaria.'
  }, {
    title: 'Hoja de Trabajo',
    desc: "'Mi Altar de Mañana' para personalizar tu rutina de Gracia."
  }, {
    title: 'Bono Especial',
    desc: 'Guía de Emergencia para días de crisis profunda.',
    isBonus: true
  }];
  return <section className="py-20 md:py-24 px-6 bg-white" data-id="element-118">
      <div className="max-w-4xl mx-auto" data-id="element-119">
        <FadeIn data-id="element-120">
          <h2 className="font-serif text-3xl md:text-4xl text-navy mb-12 text-center" data-id="element-121">
            Lo que recibes hoy
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-122">
          {items.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-123">
              <div className={`p-6 rounded-2xl h-full border ${item.isBonus ? 'bg-gold/5 border-gold/20' : 'bg-cream border-divider/50'}`} data-id="element-124">
                <div className="flex items-start gap-4" data-id="element-125">
                  <div className={`flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center ${item.isBonus ? 'bg-gold text-white' : 'bg-navy/5 text-navy'}`} data-id="element-126">
                    {item.isBonus ? <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-127">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7" data-id="element-128" />
                      </svg> : <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-129">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-130" />
                      </svg>}
                  </div>
                  <div data-id="element-131">
                    <h3 className="font-serif text-xl text-navy mb-1" data-id="element-132">
                      {item.title}
                    </h3>
                    <p className="text-navy/70" data-id="element-133">{item.desc}</p>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}